import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";

bootstrapUtils.addStyle(Button, "grey");

function EquityButton(props) {
  const { onClick, disabled } = props;

  const style = disabled === true ? "grey" : "primary";

  return (
    <Button
      className="btn-fn-decisions-button ml-20"
      bsStyle={style}
      onClick={onClick}
      disabled={disabled}
    >
      Equity
    </Button>
  );
}

export default EquityButton;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/equity-button.js